import React from 'react';
import AuthForm from './AuthForm';
import { COLORS } from '../../../utils/constants';
import './AuthModal.css';

const AuthModal = ({ isOpen, onClose, mode, onSwitchMode, referralCode }) => {
  if (!isOpen) return null;

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="auth-modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="auth-modal-header">
          <h2>{mode === 'login' ? 'Login to Your Account' : 'Create New Account'}</h2>
          <p>
            {mode === 'login' ? "Don't have an account? " : "Already have an account? "}
            <button 
              className="switch-mode-button"
              onClick={() => onSwitchMode(mode === 'login' ? 'register' : 'login')}
              style={{ color: COLORS.PRIMARY }}
            >
              {mode === 'login' ? 'Sign up' : 'Login'}
            </button>
          </p>
        </div>
        
        <AuthForm 
          mode={mode} 
          onSuccess={onClose}
          referralCode={referralCode}
        />
      </div>
    </div>
  );
};

export default AuthModal;